function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30 6H6C5.60218 6 5.22064 6.15804 4.93934 6.43934C4.65804 6.72064 4.5 7.10218 4.5 7.5V12C4.5 12.3978 4.65804 12.7794 4.93934 13.0607C5.22064 13.342 5.60218 13.5 6 13.5C6.39782 13.5 6.77936 13.342 7.06066 13.0607C7.34196 12.7794 7.5 12.3978 7.5 12V9H16.5V28.5H13.5C13.1022 28.5 12.7206 28.658 12.4393 28.9393C12.158 29.2206 12 29.6022 12 30C12 30.3978 12.158 30.7794 12.4393 31.0607C12.7206 31.342 13.1022 31.5 13.5 31.5H22.5C22.8978 31.5 23.2794 31.342 23.5607 31.0607C23.842 30.7794 24 30.3978 24 30C24 29.6022 23.842 29.2206 23.5607 28.9393C23.2794 28.658 22.8978 28.5 22.5 28.5H19.5V9H28.5V12C28.5 12.3978 28.658 12.7794 28.9393 13.0607C29.2206 13.342 29.6022 13.5 30 13.5C30.3978 13.5 30.7794 13.342 31.0607 13.0607C31.342 12.7794 31.5 12.3978 31.5 12V7.5C31.5 7.10218 31.342 6.72064 31.0607 6.43934C30.7794 6.15804 30.3978 6 30 6Z",
  fill: "#F5F5F5"
});

function SvgText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/Text.dfe7b33a.svg";
export { ForwardRef as ReactComponent };